import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Box } from '@mui/material';
import { forwardRef } from 'react';
import { ContentComponent } from './components/ContentComponent.js';
import { LabelComponent } from './components/LabelComponent.js';

const Item = forwardRef(function GridItemComponent(_a, ref) {
    var { children, label = null, labelTypography = {}, sxLabel = {}, isRequired = false, sxContent = {}, contentTypography = {}, sm = 6, labelEndAdornment } = _a, rest = __rest(_a, ["children", "label", "labelTypography", "sxLabel", "isRequired", "sxContent", "contentTypography", "sm", "labelEndAdornment"]);
    return (jsxs(GridItem, Object.assign({ "$sm": sm, ref: ref }, rest, { children: [jsx(LabelComponent, { endAdornment: labelEndAdornment, isRequired: isRequired, sx: sxLabel, typographyProps: labelTypography, children: label }), jsx(ContentComponent, { sx: sxContent, typographyProps: contentTypography, children: children })] })));
});
const GridItem = styled(Box)(({ theme, $sm }) => ({
    padding: theme.spacing(1.5, 0),
    wordBreak: "break-word",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    gridColumn: `span ${$sm}`,
}));

export { Item };
//# sourceMappingURL=CardItem.js.map
